import {Injectable} from '@angular/core';
import {SasListManager} from '../../../data/manager-v3/sas-subscription/sas-list/sas-list.manager';
import {LocalStorageManager} from '../../../data/manager/local-storage/local-storage.manager';

@Injectable({
  providedIn: 'root',
})
export class MyDeliveryVm {
  constructor(private sasListManager: SasListManager,
              private lsm: LocalStorageManager) { }

  getDeliveryByShipping() {
    return this.sasListManager.getDeliveryByShipping();
  }

  getCustomer() {
    return this.lsm.get('customer');
  }

  getDeliveryByShippingDetail(CustomerId, event) {
    return this.sasListManager.getDeliveryByShippingDetail(CustomerId, event);
  }
}
